import { render } from "./UserUsageReport.vue?vue&type=template&id=5456e220&scoped=true&lang=pug"
import script from "./UserUsageReport.vue?vue&type=script&lang=js"
export * from "./UserUsageReport.vue?vue&type=script&lang=js"

import "./UserUsageReport.vue?vue&type=style&index=0&id=5456e220&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5456e220"]])

export default __exports__